import React, { useEffect } from 'react'
import $t from '../../../../i18n'
import Card from 'components/common/Card'
import { useSelector } from 'react-redux'
import { BenefitTypeNames, SSO } from 'consts/coverageBenefitsConsts'
import dentalLogo from 'resources/DentalBenefitLogo.svg'
import medicationLogo from 'resources/MedicationBenefitLogo.svg'
import visionLogo from 'resources/VisionBenefitLogo.svg'

import './BenefitLinkCard.css'

const BenefitLinkCard = ({ type, onClick }) => {
  const authenticatedLinks = useSelector(
    state => state.profile?.authenticatedLinks
  )

  const getBenefitLink = benefitType => {
    const linkName = `${benefitType}_portal`
    return authenticatedLinks?.[SSO]?.[linkName]
  }

  const benefitTypesMap = {
    [BenefitTypeNames.MEDICATION]: {
      logo: medicationLogo,
      title: $t('pages.coverageBenefits.medication'),
      link: getBenefitLink(BenefitTypeNames.MEDICATION),
    },
    [BenefitTypeNames.DENTAL]: {
      logo: dentalLogo,
      title: $t('pages.coverageBenefits.dental'),
      link: getBenefitLink(BenefitTypeNames.DENTAL),
    },
    [BenefitTypeNames.VISION]: {
      logo: visionLogo,
      title: $t('pages.coverageBenefits.vision'),
      link: getBenefitLink(BenefitTypeNames.VISION),
    },
  }

  const benefit = benefitTypesMap[type]

  return (
    <Card
      className="benefits-links-card trackable"
      data-name="benefit-card"
      onClick={() => onClick(benefit?.link)}
    >
      <div className="benefit-card-link">
        <div className="benefit-card-link-title benefit-link-title">
          <img
            src={benefit?.logo}
            alt="coverage-benefits"
            className="benefits-image"
          />
          <h2 className="coverage-benefits-card-title semi-bold">
            {benefitTypesMap[type]?.title}
          </h2>
        </div>
        <i className="icon-export"></i>
      </div>
    </Card>
  )
}

export default BenefitLinkCard
